<p-dialog [(visible)]="visible"
          class="detail-reservation-trajet"
          styleClass="dialog-detail-reservation-trajet"
          [dismissableMask]="true"
          [modal]="true"
          (onHide)="reinitialiserDetailReservationTrajet()">
	<p-header>
		<span>
			{{ (estTrajetReserve() ? 'RESERVATION_NAVETTE.TITRE_POPUP_DEJA_RESERVE' : 'RESERVATION_NAVETTE.TITRE_POPUP_RESERVATION') | translate }}
			<span class="date-titre">{{ trajet()?.dateDepart | date: 'EEEE dd/MM' }}</span>
		</span>
	</p-header>
	<alert [nom]="NOM_ALERTE_DETAIL_RESERVATION"></alert>
	@if (actionEnCours()) {
		<p-progressSpinner></p-progressSpinner>
	} @else if (trajet()) {
		<div class="contenu-detail">
			<div class="section-detail-reservation">
				<app-affichage-depart-arrivee [trajet]="trajet()"></app-affichage-depart-arrivee>
			</div>
			<div class="section-statut-trajet">
				<app-label-statut-trajet [statut]="statutTrajet()"></app-label-statut-trajet>
			</div>
			<div class="nombre-places-restantes">
				{{ 'GESTION_NAVETTE.TRAJETS.NOMBRE_PLACES_RESTANTES' | translate : { nombre: trajet().nombrePlaces - trajet().nombreReservations, total: trajet().nombrePlaces } }}
			</div>
			<app-informations-utiles [informations]="trajet().information" [afficherTitre]="false"></app-informations-utiles>
		</div>
		<p-footer>
			<div class="boutons">
				@if (estTrajetReservable()) {
					<p-button label="{{ 'RESERVATION_NAVETTE.DETAIL.BTN_RESERVER' | translate }}"
					          (onClick)="afficherPopupConfirmationReservation()"
					          [disabled]="estTrajetComplet()"/>
				} @else if (estTrajetReserve()) {
					<p-button label="{{ 'RESERVATION_NAVETTE.ANNULATION.BTN_ANNULER_RESERVATION' | translate }}"
					          (onClick)="afficherPopupConfirmationAnnulation()"
					          severity="danger"
					          [disabled]="!estTrajetAnnulable()"/>
				}
			</div>
		</p-footer>
	}
</p-dialog>